// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__30OJW","video":"video_video__ZRHIw","title":"video_title__B--4y"};